<template>
  <v-row no-gutters>
    <v-col cols="12" v-if="runningTACContracts && runningTACContracts.find((cont) => cont.NAME.includes('PREMIUM'))">
      <v-card-title class="font-weight-bold">
        Premium Kunde Gast Eintritte seit
        {{ this.$moment(runningTACContracts.find((cont) => cont.NAME.includes("PREMIUM")).TERM_STARTDATE).format("DD.MM.YYYY") }}
      </v-card-title>
      <v-row no-gutters class="px-4">
        <v-col v-for="n in maxGuestEntries" :key="'guestentries' + n" cols="auto">
          <v-chip
            @click="filteredGuestEntries.length === n - 1 ? (createNewGuestEntry = true) : showGuestEntry(n)"
            class="mr-2"
            :class="{ 'font-weight-bold clickable': filteredGuestEntries.length === n - 1 }"
            :color="n > filteredGuestEntries.length ? 'grey' : 'primary'">
            {{ filteredGuestEntries.length === n - 1 ? "+" : n }}
          </v-chip>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-row no-gutters>
        <v-col align="center" cols="12">
          <v-tabs class="mt-5" v-model="tab" centered dark>
            <v-tab v-for="(tab, index) of tabs" :key="index">{{ tab.text }}</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row v-if="userService.hasRight('c_create_customer')" no-gutters>
        <v-col cols="12">
          <v-tabs-items dark v-model="tab">
            <v-tab-item>
              <v-row no-gutters>
                <v-col class="px-5 mt-5" cols="12" v-if="!contracts || contracts.length === 0">
                  <v-alert type="info">Keine Verträge gefunden</v-alert>
                </v-col>
                <v-col v-for="(contract, index) of contracts" :key="index + '-roodyContract'" :cols="isMobile ? '12' : '6'">
                  <v-card class="mt-8 mx-5 fill-height" color="grey darken-4" align="center">
                    <v-chip style="margin-top: -20px" :color="mapContractState(contract.status).color">
                      {{ mapContractState(contract.status).text }}
                    </v-chip>
                    <v-card-title v-if="contract.membership && contract.membership.selection" class="justify-center pt-0">
                      {{ contract.membership.selection.title }}
                    </v-card-title>
                    <v-card-subtitle v-else>Fehler bei Mitgliedschaft</v-card-subtitle>
                    <v-card-subtitle v-if="contract.category && contract.category.selection" class="justify-center pb-0">
                      {{ contract.category.selection.title }}
                    </v-card-subtitle>
                    <v-card-subtitle v-else>Fehler bei Kategorie</v-card-subtitle>
                    <v-card-text class="pb-0">
                      <div>
                        {{ $moment(contract.startDate).format("DD.MM.YYYY") }} -
                        {{ $moment(contract.endDate).format("DD.MM.YYYY") }}
                      </div>
                    </v-card-text>
                    <v-card-text v-if="contract.hasPurchasedPersonalTraining">
                      <v-icon>mdi-information</v-icon>
                      Personal Training gekauft
                    </v-card-text>
                    <v-card-text class="text-center">
                      <v-chip
                        closable
                        @click:close="openTerminationDialog(packagee)"
                        v-for="(packagee, index2) of contract.packages"
                        :key="index2 + '-runningTACAdditionalContract'">
                        {{ packagee.title }}
                      </v-chip>
                    </v-card-text>
                    <v-card-actions>
                      <v-row no-gutters>
                        <v-col align="center" cols="12">
                          <v-btn v-if="contract.status !== 'accepted'" @click="showPaymentDialog = index + '-contractPaymentIndex'" icon>
                            <v-icon>mdi-credit-card-settings-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="contract.status !== 'accepted'" @click="showAttachmentDialog = user._id + '-' + index" icon>
                            <v-icon>mdi-file-image-plus</v-icon>
                          </v-btn>
                          <v-btn v-if="contract.status === 'accepted' || contract.status === 'deleted'" @click="declineContract(index)" icon>
                            <v-icon>mdi-block-helper</v-icon>
                          </v-btn>
                          <v-btn v-if="contract.status !== 'accepted'" @click="showEditDialog = index + '-contractEditIndex'" icon>
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn @click="$router.push('/dashboard/contract/view/' + user._id + '/' + index)" icon>
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                          <v-btn icon @click="printUserContract(index)">
                            <v-icon>mdi-printer</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>

                  <basic-dialog
                    ref="paymentDialog"
                    dialogTitle="Zahlungsbedingungen"
                    @onCancel="showPaymentDialog = null"
                    :dialogVisible="showPaymentDialog === index + '-contractPaymentIndex'"
                    @onSave="editPaymentContract(index, contract.paymentOptions)"
                    :dialogSaveButtonText="'Speichern'"
                    dark>
                    <v-row no-gutters class="pa-4">
                      <v-col class="d-flex justify-center mb-5" v-if="!tempContract" cols="12">
                        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                      </v-col>

                      <v-col v-else cols="12" class="mb-2">
                        <div class="text-subtitle-1 grey--text text--lighten-1 mb-4">Bitte wähle eine Zahlungsoption:</div>
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            v-for="(paymentOption, i) of tempContract.formFields
                              .find((e) => e.inputType === 'paymentOptions')
                              .inputValue.filter((e) => e.studios.includes(contract.studio._id))"
                            :key="i + '-indexPaymentOptions'"
                            class="mb-3">
                            <v-card
                              hover
                              rounded="lg"
                              :color="
                                contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title
                                  ? 'primary'
                                  : 'grey darken-3'
                              "
                              :class="{
                                'elevation-4': contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title,
                              }"
                              @click="
                                contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title
                                  ? (contract.paymentOptions = {
                                      selection: null,
                                      selectedDate: null,
                                      additionalInfo: contract.paymentOptions.additionalInfo || '',
                                    })
                                  : (contract.paymentOptions = {
                                      selection: paymentOption,
                                      selectedDate: null,
                                      additionalInfo: contract.paymentOptions.additionalInfo || '',
                                    })
                              "
                              class="transition-swing clickable-card">
                              <v-card-text class="d-flex align-center py-4 px-5">
                                <v-icon
                                  :color="
                                    contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title
                                      ? 'white'
                                      : 'grey darken-1'
                                  "
                                  class="mr-4"
                                  large>
                                  {{
                                    contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title
                                      ? "mdi-check-circle"
                                      : "mdi-circle-outline"
                                  }}
                                </v-icon>
                                <span
                                  class="text-body-1 font-weight-medium"
                                  :class="
                                    contract.paymentOptions.selection && contract.paymentOptions.selection.title === paymentOption.title
                                      ? 'white--text'
                                      : 'grey--text text--lighten-2'
                                  ">
                                  {{ paymentOption.title }}
                                </span>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col class="mb-2 mt-4" v-if="tempContract" cols="12">
                        <v-divider class="mb-6 border-opacity-25"></v-divider>
                        <v-textarea
                          outlined
                          rounded="lg"
                          background-color="grey darken-4"
                          label="Zusätzliche Informationen"
                          counter
                          rows="3"
                          :rules="[
                            (v) => (v || '').length <= 150 || 'Bitte nur maximal 150 Zeichen eingeben',
                            (v) => !v || v.indexOf('\n') < 0 || 'Bitte keine Zeilenumbrüche eingeben',
                          ]"
                          v-model="contract.paymentOptions.additionalInfo"></v-textarea>
                      </v-col>
                    </v-row>
                  </basic-dialog>

                  <basic-dialog
                    ref="editDialog"
                    dialogTitle="Vertrag bearbeiten"
                    @onCancel="showEditDialog = null"
                    :dialogVisible="showEditDialog === index + '-contractEditIndex'"
                    @onSave="$router.push('/dashboard/contract/edit/' + user._id + '/' + index)"
                    :dialogSaveButtonText="'Fortfahren'"
                    dark>
                    <v-row class="pa-4">
                      <v-col cols="12">
                        <v-alert type="warning" icon="mdi-alert-circle-outline" border="left" prominent rounded="lg" class="mb-6 grey darken-3">
                          Wenn du den Vertrag bearbeitest, musst du die Unterschrift des Kunden erneut einholen. Möchtest du wirklich fortfahren?
                        </v-alert>
                        <v-alert color="info" icon="mdi-information-outline" outlined rounded="lg" class="mb-0">
                          Anhänge kannst du über das
                          <v-icon color="info" small class="mx-1" @click="showEditDialog = null">mdi-file-image-plus</v-icon> Icon ohne extra
                          Unterschrift hinzufügen.
                        </v-alert>
                      </v-col>
                    </v-row>
                  </basic-dialog>

                  <basic-dialog
                    ref="attachmentDialog"
                    @onCancel="showAttachmentDialog = null"
                    @onSave="addFileToContract(index)"
                    dialogTitle="Anhänge verwalten"
                    :dialogVisible="showAttachmentDialog === user._id + '-' + index"
                    dark>
                    <v-row no-gutters class="pa-4">
                      <v-col cols="12">
                        <v-file-input
                          multiple
                          outlined
                          rounded="lg"
                          prepend-icon="mdi-camera-plus"
                          background-color="grey darken-3"
                          color="primary"
                          @change="uploadImagesContract($event, contract)"
                          label="Neue Bilder auswählen"></v-file-input>
                      </v-col>

                      <v-col cols="12" v-if="contract.customer && contract.customer.additionalImages && contract.customer.additionalImages.length">
                        <v-divider class="mb-4"></v-divider>
                        <v-window v-model="activeIndexContract" class="elevation-2 rounded-lg grey darken-4">
                          <v-window-item v-for="(image, imageIndex) in contract.customer.additionalImages" :key="`card-${imageIndex}`">
                            <v-card color="transparent" height="250" class="d-flex flex-column align-center justify-center position-relative">
                              <v-img
                                v-if="image.dataUrl"
                                contain
                                height="200px"
                                width="100%"
                                :src="image.dataUrl"
                                alt="Uploaded Image"
                                class="rounded-lg"></v-img>

                              <div v-else class="text-center">
                                <v-icon size="50" color="grey darken-2" class="mb-3">mdi-image-off-outline</v-icon><br />
                                <v-btn rounded outlined color="primary" @click="fetchImageDataSource(imageIndex, contract)">
                                  <v-icon left>mdi-cloud-download</v-icon> Bild laden
                                </v-btn>
                              </div>

                              <v-btn
                                fab
                                x-small
                                color="error"
                                class="absolute-top-right mt-2 mr-2"
                                @click="deleteImageContract(imageIndex, contract)"
                                elevation="4">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </v-card>
                          </v-window-item>
                        </v-window>

                        <v-card-actions class="justify-center pt-4">
                          <v-item-group v-model="activeIndexContract" class="text-center" mandatory>
                            <v-item v-for="n in contract.customer.additionalImages.length" :key="`btn-${n}`" v-slot="{ active, toggle }">
                              <v-btn :color="active ? 'primary' : 'grey darken-2'" icon small @click="toggle">
                                <v-icon small>mdi-circle</v-icon>
                              </v-btn>
                            </v-item>
                          </v-item-group>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </basic-dialog>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-row no-gutters>
                <v-col cols="12" class="justify-center d-flex">
                  <v-switch v-model="tacContractsSwitch" label="Abgelaufene Verträge anzeigen"></v-switch>
                </v-col>
                <v-col cols="12" class="px-5 mt-5" v-if="!runningTACContracts.length > 0 && !oldTACContracts.length > 0">
                  <v-alert type="info">Keine Verträge gefunden</v-alert>
                </v-col>
                <v-col cols="12">
                  <v-row v-if="!tacContractsSwitch" no-gutters>
                    <v-col
                      v-for="(contract, index) of runningTACContracts.filter(
                        (e) => e.CONTRACTTYP === 'Hauptvertrag' || (e.CONTRACTTYP === 'Bonusvertrag' && e.GROUP_NAME !== 'Zusatzpakete'),
                      )"
                      :key="index + '-runningTACContract'"
                      :cols="isMobile ? '12' : '6'">
                      <v-card color="grey darken-4" align="center" class="mx-5 mb-8">
                        <v-card-title class="justify-center">{{ contract.NAME }}</v-card-title>
                        <v-card-subtitle v-if="contract.TERM_TYPE" class="justify-center pb-0">
                          {{ contract.TERM_TYPE }}
                        </v-card-subtitle>
                        <v-card-text class="pb-0">
                          <div>
                            {{ $moment(contract.TERM_STARTDATE).format("DD.MM.YYYY") }} -
                            {{ $moment(contract.TERM_ENDDATE).format("DD.MM.YYYY") }}
                          </div>
                        </v-card-text>
                        <v-card-text class="text-center">
                          <v-chip
                            v-for="(additionalContract, index2) of runningTACContracts.filter(
                              (e) => e.CONTRACTTYP === 'Zusatzvertrag' || (e.CONTRACTTYP === 'Bonusvertrag' && e.GROUP_NAME === 'Zusatzpakete'),
                            )"
                            v-show="
                              additionalContract.TERM_STARTDATE === contract.TERM_STARTDATE &&
                              additionalContract.TERM_ENDDATE === contract.TERM_ENDDATE
                            "
                            class="primary accent-4 white--text mx-1"
                            :key="index2 + '-runningTACAdditionalContract'"
                            close
                            title="Zusatzpaket kündigen"
                            @click:close="openTerminationDialog(additionalContract)">
                            {{ additionalContract.NAME }}
                          </v-chip>
                        </v-card-text>
                        <v-row v-if="userService.hasRight('d_c_healthcare')" no-gutters>
                          <v-col
                            cols="12"
                            v-for="year of $moment(contract.TERM_ENDDATE).diff($moment(contract.TERM_STARTDATE), 'years') + 1"
                            :key="year + 'contractYear'"
                            class="d-flex justify-center"
                            align="center">
                            <v-row no-gutters>
                              <v-col class="d-flex justify-center" cols="12">
                                <v-switch
                                  :label="year + ' Jahr ' + 'vollständig bezahlt'"
                                  @change="updateContractPayment($event, contract.CONTRACTIDSEQUENCEID, 0, year)"
                                  :input-value="
                                    user.paidTACContractIDs &&
                                    user.paidTACContractIDs.find(
                                      (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                    )
                                  "></v-switch>
                              </v-col>
                              <v-col
                                v-if="
                                  user.paidTACContractIDs &&
                                  user.paidTACContractIDs.find((e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year)
                                "
                                cols="12">
                                <v-text-field
                                  type="number"
                                  class="mx-5"
                                  :value="
                                    user.paidTACContractIDs &&
                                    user.paidTACContractIDs.find(
                                      (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                    )
                                      ? user.paidTACContractIDs.find(
                                          (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                        ).amount
                                      : 0
                                  "
                                  @blur="updateContractPayment(true, contract.CONTRACTIDSEQUENCEID, $event.target.value, year)"
                                  label="Kosten des Abos (KK-Bestätigung)"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-spacer></v-spacer>
                        <v-card-actions v-if="userService.hasRight('c_open_contracts')" class="justify-center">
                          <v-btn color="error" fab small @click="openTerminationDialog(contract)" title="Vertrag kündigen">
                            <v-icon>mdi-file-cancel-outline</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else no-gutters>
                    <v-col
                      v-for="(contract, index) of oldTACContracts.filter(
                        (e) => e.CONTRACTTYP === 'Hauptvertrag' || (e.CONTRACTTYP === 'Bonusvertrag' && e.GROUP_NAME !== 'Zusatzpakete'),
                      )"
                      :key="index + '-runningTACContract'"
                      :cols="isMobile ? '12' : '6'">
                      <v-card color="grey darken-4" align="center" class="mx-5 mb-8">
                        <v-card-title class="justify-center">
                          {{ contract.NAME }}
                          <br />
                          (abgelaufen)
                        </v-card-title>
                        <v-card-subtitle v-if="contract.TERM_TYPE" class="justify-center pb-0">
                          {{ contract.TERM_TYPE }}
                        </v-card-subtitle>
                        <v-card-text class="pb-0">
                          <div>
                            {{ $moment(contract.TERM_STARTDATE).format("DD.MM.YYYY") }} -
                            {{ $moment(contract.TERM_ENDDATE).format("DD.MM.YYYY") }}
                          </div>
                        </v-card-text>
                        <v-card-text class="text-center">
                          <v-chip
                            v-for="(additionalContract, index2) of oldTACContracts.filter(
                              (e) => e.CONTRACTTYP === 'Zusatzvertrag' || (e.CONTRACTTYP === 'Bonusvertrag' && e.GROUP_NAME === 'Zusatzpakete'),
                            )"
                            v-show="
                              additionalContract.TERM_STARTDATE === contract.TERM_STARTDATE &&
                              additionalContract.TERM_ENDDATE === contract.TERM_ENDDATE
                            "
                            class="primary accent-4 white--text mx-1"
                            :key="index2 + '-runningTACAdditionalContract'">
                            {{ additionalContract.NAME }}
                          </v-chip>
                        </v-card-text>
                        <v-row v-if="userService.hasRight('d_c_healthcare')" no-gutters>
                          <v-col
                            cols="12"
                            v-for="year of $moment(contract.TERM_ENDDATE).diff($moment(contract.TERM_STARTDATE), 'years') + 1"
                            :key="year + 'contractYear'"
                            class="d-flex justify-center"
                            align="center">
                            <v-row no-gutters>
                              <v-col class="d-flex justify-center" cols="12">
                                <v-switch
                                  :label="year + ' Jahr ' + 'vollständig bezahlt'"
                                  @change="updateContractPayment($event, contract.CONTRACTIDSEQUENCEID, 0, year)"
                                  :input-value="
                                    user.paidTACContractIDs &&
                                    user.paidTACContractIDs.find(
                                      (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                    )
                                  "></v-switch>
                              </v-col>
                              <v-col
                                v-if="
                                  user.paidTACContractIDs &&
                                  user.paidTACContractIDs.find((e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year)
                                "
                                cols="12">
                                <v-text-field
                                  type="number"
                                  class="mx-5"
                                  :value="
                                    user.paidTACContractIDs &&
                                    user.paidTACContractIDs.find(
                                      (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                    )
                                      ? user.paidTACContractIDs.find(
                                          (e) => e.id.toString() === contract.CONTRACTIDSEQUENCEID.toString() && e.year === year,
                                        ).amount
                                      : 0
                                  "
                                  @blur="updateContractPayment(true, contract.CONTRACTIDSEQUENCEID, $event.target.value, year)"
                                  label="Kosten des Abos (KK-Bestätigung)"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12" class="px-5 mt-5">
          <v-alert type="info">Funktion nicht freigeschaltet</v-alert>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog max-width="500" dark v-model="createNewGuestEntry" transition="dialog-bottom-transition">
      <v-card rounded="lg" color="grey darken-4" elevation="12">
        <v-card-title class="pa-5 border-bottom d-flex justify-space-between align-center">
          <span class="text-h6 font-weight-bold">Gast Eintritt</span>
          <v-chip color="primary" outlined small>
            {{ newGuestEntry.date.format("DD.MM.YYYY") }}
          </v-chip>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="text-body-2 grey--text text--lighten-1 mb-4">Suche nach einem bestehenden Gast oder erstelle einen neuen Account.</div>
          <user-search
            :key="newGuestEntry.user"
            class="mx-auto"
            ignoreRights
            :value="newGuestEntry.user"
            label="Gast suchen..."
            outlined
            @update="setGuestUser($event)"></user-search>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 flex-wrap justify-center" style="gap: 10px">
          <v-btn v-if="!newGuestEntry.user" color="primary" outlined rounded block @click="showRegisterDialog = true">
            <v-icon left>mdi-account-plus</v-icon> Neuen Account erstellen
          </v-btn>

          <template v-else>
            <v-btn :loading="loadingExistingDocs" outlined rounded color="info" block class="mb-2" @click="createOrEditAnamnese()">
              <v-icon left>{{
                existingDocs && existingDocs.medicalHistory && existingDocs.medicalHistory.length
                  ? "mdi-file-document-edit"
                  : "mdi-file-document-plus"
              }}</v-icon>
              {{ existingDocs && existingDocs.medicalHistory && existingDocs.medicalHistory.length ? "Anamnese bearbeiten" : "Anamnese erstellen" }}
            </v-btn>

            <v-btn
              rounded
              block
              :disabled="!existingDocs || !existingDocs.medicalHistory || !existingDocs.medicalHistory.length"
              :loading="loadingExistingDocs"
              color="primary"
              elevation="4"
              @click="updateUserGuestEntries()">
              <v-icon left>mdi-content-save</v-icon> Eintritt speichern
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <register
      @register="newAccountRegistered()"
      :auto-login="false"
      :requirePassword="false"
      @close="showRegisterDialog = false"
      :active="showRegisterDialog"></register>

    <anamnese-bogen-create @submitted="fetchExistingGuestDocs(newGuestEntry.user)" ref="anamneseBogenRef"></anamnese-bogen-create>

    <v-dialog max-width="400" dark v-model="showPremiumDialog" transition="fade-transition">
      <v-card rounded="lg" color="grey darken-4" elevation="12" v-if="showExistingGuestEntry">
        <v-card-title class="pa-5 d-flex justify-space-between align-center">
          <span class="text-h6">Eintritt Details</span>
          <v-btn icon color="error" @click="deletePremiumGuest" title="Eintritt löschen">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text-center pt-2 pb-6">
          <v-icon size="40" color="primary" class="mb-3">mdi-calendar-check</v-icon>
          <div class="text-h5 white--text mb-1">{{ $moment(showExistingGuestEntry.date).format("DD.MM.YYYY") }}</div>
          <div class="grey--text">Erfasster Gast-Eintritt</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 d-flex flex-column align-stretch" style="gap: 12px">
          <v-btn rounded color="primary" elevation="2" @click="$router.push('/dashboard/user/search/' + showExistingGuestEntry.user)">
            <v-icon left>mdi-account-arrow-right</v-icon> Profil öffnen
          </v-btn>
          <v-btn rounded text color="grey" @click="showExistingGuestEntry = null"> Schliessen </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <termination-dialog
      v-if="user"
      :dialog="terminationDialog"
      :user="user"
      :contract-id="selectedContractId"
      @close="
        terminationDialog = false
        selectedContractId = null
      "></termination-dialog>
  </v-row>
</template>
<script>
import api from "@/api"
import anamneseBogenCreate from "../../../components/anamneseBogenCreate"

import userService from "@/services/userService"
import register from "@/views/launchScreen/register.vue"
import userSearch from "@/components/userSearch.vue"
import basicDialog from "@/components/tools/basicDialog"
import terminationDialog from "./userDashboardTerminationDialog.vue" // Pfad anpassen
export default {
  components: { basicDialog, register, userSearch, anamneseBogenCreate, terminationDialog },
  props: {
    user: {
      required: true,
    },
    isMobile: {
      required: true,
    },
  },
  data() {
    return {
      showRegisterDialog: false,
      guestEntries: [],
      createNewGuestEntry: false,
      newGuestEntry: { user: null, date: this.$moment() },
      userService,
      activeIndexContract: 0,
      tempContract: null,
      showEditDialog: null,
      showAttachmentDialog: null,
      showPaymentDialog: null,
      tacContractsSwitch: false,
      imageSources: {},
      tab: null,
      tabs: [
        {
          text: "roody Verträge",
        },
        {
          text: "TAC Verträge",
        },
      ],
      contracts: null,
      tacContractInfos: null,
      loading: false,
      existingDocs: null,
      loadingExistingDocs: false,
      showExistingGuestEntry: null,
      terminationDialog: false,
      selectedContractId: null,
    }
  },
  async created() {
    this.fetchTACContractInfos()
    this.fetchContracts()

    if (this.user.guestEntries) {
      this.guestEntries = JSON.parse(JSON.stringify(this.user.guestEntries))
    }
  },
  methods: {
    deletePremiumGuest() {
      if (confirm("Möchtest du die Einträge vom " + this.$moment(this.showExistingGuestEntry.date).format("DD.MM.YYYY") + " wirklich löschen?")) {
        api.updateUserGuestEntries({
          userId: this.user._id,
          guestEntries: this.guestEntries.filter((e) => e.date.toString() !== this.showExistingGuestEntry.date.toString()),
        })
        this.guestEntries = this.guestEntries.filter((e) => e.date.toString() !== this.showExistingGuestEntry.date.toString())
        this.showExistingGuestEntry = null

        this.$emit("refetchUser")
      }
    },
    openTerminationDialog(contract) {
      console.log("OPEN TERMINATION DIALOG", contract)
      // Wir brauchen die CONTRACTID des Hauptvertrags
      this.selectedContractId = contract.CONTRACTID
      this.terminationDialog = true
    },
    showGuestEntry(index) {
      console.log("SHOW")
      this.showExistingGuestEntry = this.filteredGuestEntries[index - 1]
      console.log(this.showExistingGuestEntry)
    },
    createOrEditAnamnese() {
      if (this.existingDocs?.medicalHistory?.length) {
        this.$refs.anamneseBogenRef.setVisible(this.existingDocs.medicalHistory[0]._id, true)
      } else {
        this.$refs.anamneseBogenRef.setVisible(null, true, false, this.newGuestEntry.user, userService.getUserId())
      }
    },
    async setGuestUser(id) {
      this.newGuestEntry.user = id
      this.fetchExistingGuestDocs(id)
    },
    async fetchExistingGuestDocs(id) {
      this.loadingExistingDocs = true
      this.existingDocs = await api.getCustomerDocuments(id)
      this.loadingExistingDocs = false
    },
    newAccountRegistered() {
      this.showRegisterDialog = false
      this.$toast.success("Neuer Account erfolgreich erstellt. Du kannst den Kunden nun auswählen")
    },
    async updateUserGuestEntries() {
      this.guestEntries.push(this.newGuestEntry)
      await api.updateUserGuestEntries({ userId: this.user._id, guestEntries: this.guestEntries })

      this.$emit("refetchUser")
      this.createNewGuestEntry = false
      this.newGuestEntry = { user: null, date: this.$moment() }
    },
    async updateContractPayment(value, contractId, amount = 0, year) {
      let updateRequestData = {
        amount,
        value,
        year,
        contractIdSequenceId: contractId.toString(),
        userId: this.user._id,
      }
      try {
        let status = await api.updateTACContractPaidStatus(updateRequestData)
        console.log(status)
        this.$toast.success("Status aktualisiert")
        this.$emit("refetchUser")
      } catch (e) {
        this.$toast.error("Fehler beim aktualisieren")
      }
    },
    async fetchImageDataSource(imageIndex, contract) {
      let image = contract.customer.additionalImages[imageIndex]
      let src = image.src

      try {
        const response = await api.fetchContractImageData(src)
        contract.customer.additionalImages[imageIndex].dataUrl = response
        this.$forceUpdate()
      } catch (error) {
        this.$toast.error("Fehler beim laden des Bildes")
      }
    },

    deleteImageContract(index, contract) {
      contract.customer.additionalImages.splice(index, 1)
      this.$forceUpdate()
    },
    uploadImagesContract(files, contract) {
      for (let file of files) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append("file", file)

          api
            .uploadContractImage(formData)
            .then((response) => {
              const uploadedImageName = response.name

              if (!contract.customer.additionalImages) contract.customer.additionalImages = []
              contract.customer.additionalImages.push({
                title: "",
                src: uploadedImageName,
                dataUrl: e.target.result,
              })
              this.$forceUpdate()
            })
            .catch((error) => {
              console.log("Upload failed", error)
            })
        }
        reader.readAsDataURL(file)
      }
    },
    onFileSelected(event) {
      this.uploadStatus = ""
      this.selectedFile = event.target.files[0]
    },
    async checkImageSources(imagePaths) {
      this.imageSources = []
      for (let image of imagePaths) {
        if (!this.imageSources[image]) {
          this.imageSources[image] = await api.getContractImage(image)
        }
      }
      this.$forceUpdate()
    },
    async uploadPictureNew() {
      if (!this.selectedFile) {
        this.uploadStatus = "Please select an image to upload."
        return
      }

      const formData = new FormData()
      formData.append("file", this.selectedFile)

      let uploadImg = {
        art: "contract",
        formData: formData,
      }

      this.uploadStatus = "Uploading..."

      try {
        const data = await api.uploadImage(uploadImg)

        if (data.status) {
          let editingId = this.showAttachmentDialog.split("-")[0]
          let index = this.showAttachmentDialog.split("-")[1]
          index = parseInt(index)

          this.editing.contracts[index].customer.additionalImage.push(data.name)
          this.checkImageSources(this.editing.contracts[index].customer.additionalImage)
          this.uploadStatus = "Upload successful!"
        } else {
          this.uploadStatus = "Error uploading: " + data.message
        }
      } catch (error) {
        this.uploadStatus = `Error uploading: ${error.message}`
      } finally {
        this.$refs.fileInput.value = ""
        this.selectedFile = null
      }
    },
    uploadPicture(formdata, progress, success, failure, slim) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      let uploadimg = {}
      uploadimg.art = "contract"
      uploadimg.formData = formData

      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            //this.fieldEntries.customer.additionalImage.push(data.name)
            let editingId = this.showAttachmentDialog.split("-")[0]
            let index = this.showAttachmentDialog.split("-")[1]

            index = parseInt(index)

            this.editing.contracts[index].customer.additionalImage.push(data.name)
            this.$forceUpdate()
            success(data)
          }
        })
        .catch((error) => {
          //this.fieldEntries.customer.additionalImage.push(data.name)
          this.$forceUpdate()
          failure(error)
        })
    },
    async addFileToContract(index) {
      // delete dataUrl from this.editing.contracts[index].customer.additionalImages
      if (this.contracts[index].customer.additionalImages) {
        this.contracts[index].customer.additionalImages.forEach((e) => {
          delete e.dataUrl
        })
      }
      let newAdditionalImages = this.contracts[index].customer.additionalImages
      let status = await api.addAttachmentToContract({
        additionalImages: this.contracts[index].customer.additionalImage,
        newAdditionalImages,
        userId: this.user._id,
        index,
      })
      this.showAttachmentDialog = null
      this.$toast.success("Erfolgreich gespeichert")
    },
    async editPaymentContract(index, paymentOptions) {
      try {
        let status = await api
          .updatePaymentOptionsContract({ userId: this.user._id, index, paymentOptions })
          .catch((e) => this.$toast.error("Fehler beim speichern, bitte versuche es erneut"))

        this.$toast.success("Erfolgreich gespeichert")
        this.showPaymentDialog = null
        this.fetchContracts()
      } catch (e) {
        this.$toast.error("Fehler beim speichern")
      }
    },
    async fetchContracts() {
      try {
        let dataTemp = await api.getCustomerContracts(this.user._id)
        this.contracts = dataTemp
        this.$emit("loaded")
      } catch (e) {
        this.$toast.error("Fehler beim laden der Dokumente")
      }
    },
    async declineContract(contractIndex) {
      if (confirm("Soll der Vertrag wirklich abgelehnt werden?")) {
        try {
          let status = await api.declineContract({ userId: this.user._id, contractIndex })
          this.fetchContracts()
          this.$toast.success("Vertrag erfolgreich abgelehnt")
        } catch (e) {
          this.$toast.error("Vertrag konnte nicht abgelehnt werden")
        }
      }
    },
    printUserContract(index) {
      api.printUserContract(this.user._id, index, "Mitgliedschaftsvertrag")
    },

    mapContractState(state) {
      let states = {
        rejected: { text: "Abgelehnt", color: "red" },
        created: { text: "Offen", color: "orange" },
        temporary: { text: "Temporär", color: "orange" },
        accepted: { text: "Akzeptiert", color: "green" },
        deleted: { text: "Gelöscht", color: "red" },
      }
      return states[state]
    },
    async fetchTACContractInfos() {
      try {
        let tacContractInfos = null

        tacContractInfos = await api.fetchTACContractDetails(this.user._id)

        this.tacContractInfos = tacContractInfos.sort((a, b) => {
          // Zuerst nach CONTRACTSTATE sortieren (Laufend zuoberst)
          if (a.CONTRACTSTATE === "Laufend" && b.CONTRACTSTATE !== "Laufend") {
            return -1
          }
          if (a.CONTRACTSTATE !== "Laufend" && b.CONTRACTSTATE === "Laufend") {
            return 1
          }

          // Dann nach TERM_ENDDATE sortieren (neueste zuoberst)
          const momentA = this.$moment(a.TERM_ENDDATE)
          const momentB = this.$moment(b.TERM_ENDDATE)

          if (momentA.isAfter(momentB)) {
            return -1
          }
          if (momentA.isBefore(momentB)) {
            return 1
          }

          return 0 // Keine Änderung in der Reihenfolge
        })
        console.log(this.tacContractInfos)
      } catch (e) {
        console.log("Fehler beim laden der TAC infos")
      }
    },
  },
  computed: {
    maxGuestEntries() {
      if (!this.runningTACContracts) return 0

      const premiumContract = this.runningTACContracts.find((cont) => cont.NAME.includes("PREMIUM"))
      if (!premiumContract) return 0

      const start = this.$moment(premiumContract.TERM_STARTDATE)
      const end = this.$moment(premiumContract.TERM_ENDDATE)

      // Laufzeit in Monaten berechnen (exakt berechnet und dann auf ganze Monate gerundet)
      const durationInMonths = Math.round(end.diff(start, "months", true))

      // Stellt sicher, dass es immer mindestens 1 Eintritt gibt.
      // Info: Falls Jahresabos weiterhin bei maximal 10 Einträgen gedeckelt sein sollen,
      // nutze stattdessen: return Math.min(10, Math.max(1, durationInMonths));
      return Math.max(1, durationInMonths)
    },
    showPremiumDialog() {
      return this.showExistingGuestEntry !== null
    },
    filteredGuestEntries() {
      return this.guestEntries.filter((entry) => {
        return this.$moment(this.$moment(entry.date)).isAfter(this.runningTACContracts.find((cont) => cont.NAME.includes("PREMIUM")).TERM_STARTDATE)
      })
    },
    runningTACContracts() {
      if (!this.tacContractInfos) return []

      return this.tacContractInfos.filter(
        (contract) =>
          contract.CONTRACTSTATE === "Laufend" &&
          !this.$moment().isAfter(this.$moment(contract.TERM_ENDDATE)) &&
          this.$moment().isAfter(this.$moment(contract.TERM_STARTDATE)),
      )
    },
    oldTACContracts() {
      if (!this.tacContractInfos) return []
      return this.tacContractInfos.filter(
        (contract) => !(contract.CONTRACTSTATE === "Laufend" && !this.$moment().isAfter(this.$moment(contract.TERM_ENDDATE))),
      )
    },
    isLocal() {
      return location.host.includes("local")
    },
  },
  watch: {
    showAttachmentDialog: function (val) {
      if (val) this.checkImageSources(this.contracts[this.showAttachmentDialog.split("-")[1]].customer.additionalImage)
    },
    showPaymentDialog: async function (val) {
      if (val) {
        let index = val.replace("-contractPaymentIndex", "")

        let contractId = this.contracts[parseInt(index)].contractId
        console.log(contractId)
        let contract = await api.fetchContract(contractId)
        this.tempContract = contract
      } else {
        this.tempContract = null
      }
    },
  },
}
</script>
<style scoped lang="scss">
.clickable {
  cursor: pointer;
}
</style>
